var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { clone } from "../../../../../Shared/utils/clone";
import { decrementRecipe_V2 } from "./decrementRecipe_V2";
/**
 * Removes a recipe assignment for a meal on the selectedDay.
 * This function updates the CustomizationContext which controls the Customization modal.
 * @param enableAssignRecipes
 * @param enableRemoveMeals
 * @param onlyShowDeliveryDays
 * @param template
 * @param cartMeals
 * @param daysOfWeek
 * @param selectedDay
 * @param assignmentId
 * @returns
 */
export const handleCustomizeDecrement_V2 = ({ enableAssignRecipes, enableRemoveMeals, onlyShowDeliveryDays, template, customizationMeals, daysOfWeek, selectedDay, assignmentId, recipe, programMealId, setMeals, setIsAddDisabled, setQuantity, }) => __awaiter(void 0, void 0, void 0, function* () {
    const clonedMeals = clone(customizationMeals);
    const { meals, currentAssignmentQuantity } = yield decrementRecipe_V2({
        enableAssignRecipes,
        enableRemoveMeals,
        onlyShowDeliveryDays,
        template,
        clonedMeals,
        daysOfWeek,
        selectedDay,
        recipe,
        programMealId,
        assignmentId,
    });
    setMeals(meals);
    setQuantity(currentAssignmentQuantity);
    //Add will always be enabled after decrementing
    setIsAddDisabled(false);
});
